import React from "react";

import { useAppSelector } from "../../store/reducer";
import PDFModalViewer from "@helsenorge/pdf-preview/components/pdf-modal-viewer";
import { openSkjemaSvarLink } from "../../utils/pdf-utils";

interface OppgaveSvarPDFProps {
  showPdf: boolean;
  setShowPdf: React.Dispatch<React.SetStateAction<boolean>>;
}

export const OppgaveSvarPDF = ({
  showPdf,
  setShowPdf,
}: OppgaveSvarPDFProps): React.JSX.Element | null => {
  const oppgave = useAppSelector((state) => state.oppgaveDetaljer.oppgave);
  const oppgaveSvar = oppgave?.OppgaveSvar;

  if (!oppgave) {
    return null;
  }

  return (
    <>
      {showPdf && (
        <PDFModalViewer
          onClose={() => setShowPdf(false)}
          file={openSkjemaSvarLink(
            oppgaveSvar?.Id || null,
            oppgaveSvar?.MimeType,
          )}
          fileName={oppgaveSvar?.Navn}
          showZoom={true}
          onError={() => {}}
          documentAriaLabelledBy={`vedlegg-${oppgaveSvar?.Id}-title`}
        ></PDFModalViewer>
      )}
    </>
  );
};
